import { ValidationResult } from "./interface.validation";
import {isNull} from "util";

export class NumberValidator {
    static numberFormat(item: any): ValidationResult {
        if (isNull(item.value)) {
            return {"incorrectNumberFormat": true};
        }

        return null;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/validators/number.validation.ts
 **/